import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { ActivitiesResponse, ActivityResponse } from './activities';

export interface DuplicateActivityBody {
    targetDate: string;
}

export const duplicateActivityToDate = async (activityId: string, body: DuplicateActivityBody): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.post(`/planning/activity/${activityId}/duplicate`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DuplicateActivitiesBody {
    activityIds: string[];
    targetDate: string;
}

export const duplicateActivitiesToDate = async (body: DuplicateActivitiesBody): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.post(`/planning/activities/duplicate`, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const sendPlanning = async (date: string, body: { withNotification?: boolean }): Promise<ActivitiesResponse> => {
    try {
        const response: AxiosResponse<ActivitiesResponse> = await apiClient.post('/planning/date/' + date, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const sendPlanningForActivity = async (activityId: string, body: { withNotification?: boolean }): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.post('/planning/activity/' + activityId, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const importNeeds = async (date: string): Promise<ActivitiesResponse> => {
    try {
        const response: AxiosResponse<ActivitiesResponse> = await apiClient.post('/planning/needs/import/date/' + date);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getBackPlanning = async (date: string, body: { withNotification?: boolean }): Promise<ActivitiesResponse> => {
    try {
        const response: AxiosResponse<ActivitiesResponse> = await apiClient.patch('/planning/date/' + date, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const getBackPlanningForActivity = async (activityId: string, body: { withNotification?: boolean }): Promise<ActivityResponse> => {
    try {
        const response: AxiosResponse<ActivityResponse> = await apiClient.patch('/planning/activity/' + activityId, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
